import React, { Component } from 'react';
import Header from "./header";
import "./homePage.css";
import Footer from "./footer";
import Articles from "../articles/articles";
import { Responsive, Container, Grid, Image, Card, Menu, Segment, Sidebar, Icon, Checkbox, Label, Button, Divider, Item } from 'semantic-ui-react';
import Calendar from 'react-calendar';

import DatePicker from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';
import qs from 'query-string';
import RichTextEditor from 'react-rte';
import Modal from 'react-responsive-modal';
import cookie from 'react-cookies';
import moment from 'moment';
import axios from 'axios';
import 'jodit';
import 'jodit/build/jodit.min.css';
import JoditEditor from "jodit-react";
import Config from '../../config';

import copy from 'copy-to-clipboard';
const format = 'YYYY-M-D';
const now = moment();
const ROOT_URL = Config.ROOT_URL;
class Events extends Component {

  state = {
    value: RichTextEditor.createEmptyValue(),
    open: false,
    events: [],
    currentEvent: [],
    upcomingEvents: [],
    files: [],
    uploaded: [],
    date: new Date(),
    newEventDate: new Date(),
    eventDate: [],
    isLogin: false,
    newEvent: {},
    userId: "",
    content: 'content'
  }

  uploadFiles = () => {
    const filesToUpload = this.state.files;
    if (!filesToUpload) return;
    const filesArray = Array.from(filesToUpload);
    const requests = filesArray.map((file) => {
      const fileType = file.type;
      const fileName = file.name.replace(/\.[^/.]+$/, "");
      return axios.post(
        `${ROOT_URL}/file/upload?type=${fileType}&name=${encodeURIComponent(
          fileName
        )}`
      );
    });

    axios
      .all(requests)
      .then((responses) => {
        const results = [];
        const putRequests = responses.map((resp, i) => {
          const presignedUrl = resp.data.presignedUrl;
          const url = resp.data.imagePath;
          const file = filesArray[i];
          const fileType = file.type;
          results.push({ file, url });
          return axios.put(presignedUrl, file, {
            headers: {
              "Content-Type": fileType,
              "x-amz-acl": "public-read",
            },
          });
        });
        axios.all(putRequests).then(() => {
          if (results.length) {
            var files = results;
            var img = `<img src="${files[0].url}">`;
            var content = this.state.content + img;
            var blogContent = this.state.blogContent + img;
            this.setState(
              {
                uploaded: files,
                content,
                blogContent,
              },
              () => {
                console.log("state", this.state);
              }
            );
          }
        })
          .catch((e) => {
            window.alert(`Error putting image to server: ${e.message}`);
          });
      })
      .catch((e) => {
        this.setState({
          error: e.message,
        });
      });
  };

  fileChangedHandler = (event) => {
    const files = event.target.files;
    this.setState({ files: files, uploaded: [] })
  }

  copyURL = (url) => {
    copy(url);
  }
  updateContent = (value) => {

    this.setState({ content: value })
  }
  onTextChange = (value) => {
    var newEvent = this.state.newEvent;
    newEvent.htmlcontent = value.toString('html');
    this.setState({
      newEvent: newEvent
    });
    this.setState({ value });
    if (this.props.onTextChange) {
      // Send the changes up to the parent component as an HTML string.
      // This is here to demonstrate using `.toString()` but in a real app it
      // would be better to avoid generating a string on each change.
      this.props.onTextChange(
        value.toString('html')
      );
    }
  };
  onOpenModal = () => {
    this.setState({ open: true, newEventDate: this.state.date });
  };

  onCloseModal = () => {
    this.setState({ open: false });
  };

  handleAddEvent = () => {
    this.state.newEvent.htmlcontent = this.state.content.toString('html');

    var dateStr = this.state.newEventDate.getFullYear() + "-" + (this.state.newEventDate.getMonth() + 1) + "-" + this.state.newEventDate.getDate();
    const params = new URLSearchParams();
    params.append("userId", this.state.userId);
    params.append("date", dateStr);
    params.append("image", "");
    params.append("title", this.state.newEvent.title);
    params.append("video", this.state.newEvent.video);
    params.append("desc", this.state.newEvent.desc);
    params.append("htmlcontent", this.state.newEvent.htmlcontent);

    axios.post(`${ROOT_URL}/event/create`, params)
      .then(res => {
        const results = res.data;
        console.log(results);
        this.setState({
          open: false,
        });
        if (results) {
          window.location.href = "/events";
        } else {
          console.log(res.data);

          this.setState({
            error: res.data.message,
          })
        }
      });
  }

  handleAttend = (evt) => {

    const params = new URLSearchParams();
    params.append("userId", this.state.userId);
    params.append("id", evt.id);

    axios.post(`${ROOT_URL}/event/attend`, params)
      .then(res => {
        const results = res.data;
        console.log(results);

        if (results) {
          this.onLoadEvents();
        } else {
          console.log(res.data);

          this.setState({
            error: res.data.message,
          })
        }
      });

  }

  onLoadEvents = () => {

    axios.get("/data.json")
      .then(res => {
        const results = res.data.events || [];
        console.log(results);

        if (results.length > 0) {


          var eventDate = [];
          results.map((e, i) => {
            eventDate.push(e.date);
          })
          var date = new Date();
          let d = qs.parse(this.props.location.search).d;
          if (d) {
            date = new Date();
            date.setFullYear(d.split("-")[0]);
            date.setMonth(d.split("-")[1] - 1);
            date.setDate(d.split("-")[2]);
            this.setState({
              date: date
            })
          } else {
            date = this.state.date;
          }
          var dateStr = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
          console.log(dateStr);
          var events = results.slice();
          var current = [];
          var upcoming = [];
          events.map((e, i) => {
            if (e.date === dateStr) {
              current.push(e);
              console.log(current);
            }
            if (moment(e.date).isAfter(moment(dateStr))) {
              upcoming.push(e);
            }
          });
          upcoming.sort((a, b) => moment(a.date) - moment(b.date));
          this.setState({
            events: results,
            eventDate: eventDate,
            currentEvent: current.slice(),
            upcomingEvents: upcoming
          });
        } else {
          console.log("No events found");
        }
      });
  }

  onClickDay = (date) => {
    var dateStr = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();

    var events = this.state.events.slice();
    var current = [];
    events.map((e, i) => {
      if (e.date === dateStr) {
        current.push(e);
        console.log(current);

      }
    })
    this.setState({
      currentEvent: current.slice()
    })

  }
  onChange = (date) => {

    this.setState(
      {
        date: date,
        newEventDate: date
      })
  }
  componentWillMount() {
    this.onLoadEvents();
  }

  componentDidMount() {
    var userId = cookie.load("userId");
    if (userId !== undefined)
      if (userId !== "") {
        this.setState({
          userId: userId,
          isLogin: true
        })
      }

  }

  constructor(props) {
    super(props)
  }
  updateTitle = (evt) => {
    var newEvent = this.state.newEvent;
    newEvent.title = evt.target.value;
    this.setState({
      newEvent: newEvent
    });
  }
  updateVideo = (evt) => {
    var newEvent = this.state.newEvent;
    newEvent.video = evt.target.value;
    this.setState({
      newEvent: newEvent
    });
  }
  updateDesc = (evt) => {
    var newEvent = this.state.newEvent;
    newEvent.desc = evt.target.value;
    this.setState({
      newEvent: newEvent
    });
  }
  onNewEventDateChange = date => {
    var str = date.format("YYYY-M-D");
    console.log(str);
    var d = new Date();
    d.setFullYear(str.split("-")[0]);
    d.setMonth(str.split("-")[1] - 1);
    d.setDate(str.split("-")[2]);
    console.log(d);
    this.setState({ newEventDate: d })

  }

  jodit;
  setRef = jodit => this.jodit = jodit;

  config = {
    readonly: false // all options from https://xdsoft.net/jodit/doc/
  }
  render() {


    return (
      <div className="Homepage">
        <Modal open={this.state.open} onClose={this.onCloseModal}>
          <div className="">
            <p className="loginformTitle">New Event</p>
            <div className="error loginformRow"><p>{this.state.error}</p></div>
            <div className="loginformRow">
              <input name="title" placeholder="Title" value={this.state.newEvent.title} onChange={this.updateTitle} />
            </div>
            <div className="loginformRow">
              <DatePicker
                onChange={this.onNewEventDateChange}
                selected={moment(this.state.newEventDate)}
              />
              <Segment>
                <input type="file" name="image" multiple="multiple" onChange={this.fileChangedHandler} />
                <Button content="Upload" onClick={this.uploadFiles} />
                <Divider />
                <Card.Group>{this.state.uploaded.length > 0 ? this.state.uploaded.map((file, index) => {
                  return (<Card><Image src={file.url} size='small' /><Card.Content><Card.Meta>{file.url} <Button content="Copy to Clipboard" onClick={() => this.copyURL(file.url)} /></Card.Meta></Card.Content></Card>)
                }) : ""}
                </Card.Group>
              </Segment>
              <div className="loginformRow">
                <input name="video" placeholder="Video URL" value={this.state.newEvent.video} onChange={this.updateVideo} />
              </div>
            </div>
            <div className="loginformRow">
              <input name="desc" placeholder="Description" value={this.state.newEvent.desc} onChange={this.updateDesc} />
            </div>
            <div className="loginformRow">

              <JoditEditor
                editorRef={this.setRef}
                value={this.state.content}
                config={this.config}
                onChange={this.updateContent}
              />
            </div>
            <div className="AddEventButton aligncenter" onClick={this.handleAddEvent}>
              <p>Save</p>
            </div>
          </div>
        </Modal>
        <Header page="aboutus" />

        <div className="homeContentWhite">
          <a id="overview">
            <Container>

              {/* {this.state.isLogin ?
                <div className="AddEventButton" onClick={this.onOpenModal}>
                  <p>Add Event</p>
                </div>
                : ""
              } */}

              <div>
                <Grid columns='equal'>
                  <Grid.Row>
                    <Grid.Column mobile={16} tablet={12} computer={12}>
                      <Item.Group>


                        {this.state.currentEvent.length > 0 ? this.state.currentEvent.map((e, i) => {
                          return (
                            <Item key={i}>
                              <Item.Content>
                                <Item.Header >{e.title}</Item.Header>
                                <Item.Description>
                                  <div className="postmeta-primary">
                                    <span className="entry-postmeta-author post-author vcard BlogUser BlogDate"><i className="fa fa-user"></i>&nbsp;<span className="fn" itemProp="author">{e.user !== undefined ? e.user.name : e.creator}</span></span>
                                    <span className="entry-postmeta-date BlogDate"><i className="fas fa-calendar"></i>&nbsp;{moment(e.date, format).format("dddd Do, MMM YYYY")}</span>&nbsp;&nbsp;
                                  </div>
                                  <div id={"desc_" + i} dangerouslySetInnerHTML={{ __html: e.htmlcontent }}></div>
                                  <Button as='div' labelPosition='right'>
                                    <Button icon onClick={() => { this.handleAttend(e) }}>
                                      {Array.isArray(e.attend) ? e.attend.some(item => item.userId === this.state.userId) ? "Applied" : "Attend" : "Attend"}

                                    </Button>
                                    <Label basic pointing='left'>
                                      {Array.isArray(e.attend) ? e.attend.length : 0}
                                    </Label>
                                  </Button>
                                </Item.Description>

                                <Divider />
                              </Item.Content>
                            </Item>
                          )
                        }) : <div className="BlogDesc">No event for {moment(this.state.date.getFullYear() + "-" + (this.state.date.getMonth() + 1) + "-" + this.state.date.getDate(), format).format("dddd Do, MMM YYYY")}</div>}

                      </Item.Group>
                      <div className="BlogDesc">Upcoming events</div>
                      {this.state.upcomingEvents.length > 0 ? this.state.upcomingEvents.map((e, i) => {
                        return (
                          <Item key={i} style={{ cursor: 'pointer' }} onClick={() => this.onClickDay(moment(e.date).toDate())}>
                            <Item.Content>
                              <Item.Header ><span className="entry-postmeta-date BlogDate"><i className="fas fa-calendar"></i>&nbsp;{moment(e.date, format).format("Do, MMM YYYY")}</span> - {e.title}</Item.Header>

                            </Item.Content>
                          </Item>
                        )
                      }) : <div className="BlogDesc">No Upcoming event</div>}
                      <Divider />
                    </Grid.Column>
                    <Grid.Column className="monza-widget-area" textAlign='right' mobile={16} tablet={4} computer={4}>
                      <div className="sidebarwidgetsarea section">
                        <div className="widget HTML">
                          <h2 className="title">RCC CALENDER</h2>
                          <div className="widget-content Calender">
                            <Calendar
                              onChange={this.onChange}
                              onClickDay={this.onClickDay}
                              value={this.state.date}
                              locale="en-GB"
                              showNeighboringMonth={false}
                              showWeekNumbers={false}
                              tileContent={({ date, view }) => {
                                var dateStr = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();

                                return (this.state.eventDate.includes(dateStr)
                                  ? <p className="eventdot"><i className="fas fa-circle"></i></p> : <p>&nbsp;</p>)
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </div>
            </Container>
          </a>
        </div>

        <Footer />
      </div>
    );
  }
}

export default Events;
